import { PermissionEnum } from '@Application/Security/Roles';
import PageHeader from '@Guidelines/Layout/PageHeader';
import FacilitiesContent from '@UI/Pages/Agencies/Facilities/FacilitiesContent';
import FacilitiesConfirmationDialogs from '@UI/Pages/Agencies/Facilities/ConfirmationDialogs/FacilitiesConfirmationDialogs';
import FacilitiesNotifications from '@UI/Pages/Agencies/Facilities/FacilitiesNotifications';
import FacilitySidebar from '@UI/Pages/Agencies/Facilities/Sidebars/FacilitySidebar';
import { openFacilitySidebar } from '@UI/Pages/Agencies/Facilities/Signals/facilitySidebarSignal';
import WithPermission from '@UI/Providers/PermissionProvider/WithPermission';
import useCurrentOrganization from '@UI/Providers/CurrentOrganizationProvider/useCurrentOrganization';
import { Plus } from 'lucide-react';
import * as React from 'react';
import { Button } from '@verclam/ui-kit';
import PageContainer from '@Guidelines/Layout/PageContainer';
import { css as toClassName } from '@emotion/css';

const containerStyle = toClassName`
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
	padding: 0 1rem;
	flex: 1;
	overflow-y: auto;
`;

/**
 * Assembles the page: header, the data-owning `FacilitiesContent`, `FacilitySidebar`,
 * `FacilitiesConfirmationDialogs` and notifications, in that visual order.
 */
const FacilitiesPage: React.FC = () => {
	const { currentOrganization } = useCurrentOrganization();
	const organizationId = currentOrganization?.id ?? null;

	const handleCreateClick = React.useCallback(() => {
		openFacilitySidebar(null);
	}, []);

	const eyebrow = currentOrganization !== null ? `STRUCTURE · ${currentOrganization.name}` : 'STRUCTURE';

	return (
		<PageContainer className={containerStyle}>
			<PageHeader
				eyebrow={eyebrow}
				title="Agences"
				description={`Gérez les agences de la structure ${currentOrganization?.name ?? ''}.`}
				actions={
					organizationId && (
						<WithPermission permission={PermissionEnum.FACILITY_WRITE}>
							<Button
								type="button"
								label="Nouvelle agence"
								icon={<Plus size={16} />}
								onClick={handleCreateClick}
							/>
						</WithPermission>
					)
				}
			/>
			<FacilitiesContent />
			<FacilitySidebar />
			<FacilitiesConfirmationDialogs />
			<FacilitiesNotifications />
		</PageContainer>
	);
};

export default FacilitiesPage;
